import React, { useMemo } from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'

import classes from './TruncatedText.module.scss'

/** @type {import("./types").default} */
const getAdaptedMaxNumberChars = (text, maxNumberChars) => {
  let adaptedMaxNumberChars = maxNumberChars
  const restOfTextSplitted = text.substr(maxNumberChars)

  for (let i = 0; i <= restOfTextSplitted.length; i += 1) {
    if (restOfTextSplitted[i] === ' ') break
    adaptedMaxNumberChars += 1
  }

  return adaptedMaxNumberChars
}

const TruncatedText = ({
  className,
  href = '',
  label = 'Read more',
  maxNumberChars = 100,
  offset = 0.2,
  onClick = () => {},
  target,
  text,
  textVariant = 'body-xs',
  hideLabel,
  ...props
}) => {
  const adaptedMaxNumberChars = useMemo(() => getAdaptedMaxNumberChars(text, maxNumberChars), [text, maxNumberChars])
  const validOffset = offset >= 0 && offset <= 1 ? offset : 0
  let visibleText = text
  let isTruncated = false

  if (text.length > maxNumberChars * (1 + validOffset)) {
    visibleText = text.substr(0, adaptedMaxNumberChars)
    isTruncated = true
  }

  return (
    <Typography component="p" variant={textVariant} className={clsx('TruncatedText', classes.text, className)}>
      <span className={clsx(classes.visibleText, { [classes.visibleTextNotTruncated]: !isTruncated })}>
        {visibleText}
      </span>
      {isTruncated && <span className={classes.ellipsis}>...</span>}
      {!hideLabel && (
        <a href={href} className={classes.link} onClick={onClick} target={target} {...props}>
          <Typography className={classes.label} component="span" variant={textVariant}>
            {label}
          </Typography>
        </a>
      )}
    </Typography>
  )
}

export default TruncatedText
